// log.service.ts
import { Injectable } from '@angular/core';
import { HttpBackend, HttpClient, HttpHeaders } from '@angular/common/http';
import { B4UService } from './b4u.service';

@Injectable({
    providedIn: 'root',
})
export class LogService {
    private windowObj: any = window;
    private http: HttpClient;
    public nodeServerurl: string;
    public httpOptions: any;
    constructor(private httBackend: HttpBackend, private b4uService: B4UService) {
        this.http = new HttpClient(httBackend);
        this.nodeServerurl = this.b4uService.getApplicationDomainURL() + '/emju-web-ui/log';
        this.httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/json' })
        };
    }

    log(message: any) {
        const logData = {
            message: message
        };
        this.http.post(this.nodeServerurl, logData, this.httpOptions).subscribe({
            next: response => {
                console.log('Log sent successfully', response);
            },
            error: error => {
                console.error('Error sending log', error);
            }
        });
    }

    logApi(payload: any) {
        const userType = this.windowObj.AB.userInfo.userType;
        let userId = "";
        if ( userType === "R") {
            userId =  this.windowObj.AB.userInfo.houseId;
            sessionStorage.removeItem('logApiUserId'); 
        } else if(userType){
            userId = sessionStorage.getItem('logApiUserId') || this.generateUUID();
            sessionStorage.setItem('logApiUserId', userId);
        }
        payload.user_type = userType || "";
        payload.user_id = userId
        this.log(JSON.stringify(payload)) ;
    }

    generateUUID(): string {
        // Fallback method to generate a UUID
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            const r = (Math.random() * 16) | 0;
            const v = c === 'x' ? r : (r & 0x3) | 0x8;
            return v.toString(16);
        });
    }

    logRoundTrip() {
        const trueEnvironment = this.b4uService.getTrueEnvironmentDevOnly();
        const requestTime = performance.now();
        const serviceName = "LogService";
        const functionName =  "logRoundTrip"
        this.http.post(this.nodeServerurl, {}, this.httpOptions).subscribe({
            next: response => {
                debugger;
                const duration = performance.now() - requestTime;
                this.logApi({
                    method: "POST",
                    uri: this.nodeServerurl,
                    response_time: duration,
                    response_code: 200,
                    request_size: "",
                    service_name: serviceName,
                    function_name: functionName,
                    environment: trueEnvironment,
                });
            },
            error: error => {
                const duration = performance.now() - requestTime;
                this.logApi({
                    method: "POST",
                    uri: this.nodeServerurl,
                    response_time: duration,
                    response_code: error.status,
                    request_size: "",
                    service_name: serviceName,
                    function_name: functionName,
                    environment: trueEnvironment,
                });
            }
        });
    }

}
